/* eslint-disable react/no-string-refs */
/**
 * Created by netre on 27.06.2017.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Map, Marker, TileLayer, ZoomControl } from 'react-leaflet';

export class DeviceMap extends React.Component {

  shouldComponentUpdate(nextProps) {
    const { mapFullscreen, position, tileUrl, icon } = this.props;

    return nextProps.mapFullscreen !== mapFullscreen ||
      position[0] !== nextProps.position[0] ||
      position[1] !== nextProps.position[1] ||
      tileUrl !== nextProps.tileUrl ||
      icon.options.html !== nextProps.icon.options.html;
  }

  render() {
    const { mapFullscreen, position, tileUrl, icon } = this.props;
    return (<Map
      ref="map"
      style={{ height: '100%' }}
      zoomControl={false}
      center={position}
      zoom={14}
      scrollWheelZoom={mapFullscreen}
      dragging={mapFullscreen}
      attributionControl={false}
    >
      <TileLayer detectRetina url={tileUrl} />
      <Marker ref="icon" icon={icon} position={position} />
      {mapFullscreen && <ZoomControl position="bottomright" />}
    </Map>
    );
  }
}

DeviceMap.propTypes = {
  mapFullscreen: PropTypes.bool.isRequired,
  position: PropTypes.arrayOf(PropTypes.number).isRequired,
  icon: PropTypes.shape({
    options: PropTypes.shape({
      html: PropTypes.string,
    }),
  }).isRequired,
  tileUrl: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/DeviceMap.js